import { useCountriesStore } from "@multicines/stores";
import { titleCase } from "@multicines/utils";
import dayjs from "dayjs";
import React from "react";
import "dayjs/locale/es";

import Styles from "./Day.styles";
import { DayProps as Props } from "./Day.types";

const Day: React.FC<Props> = props => {
  const { date, selectedDate, disabled = false, onClick } = props;
  const isSelected = date.format("D") === selectedDate?.format("D");
  const selectedCountry = useCountriesStore(state => state.selectedCountry);
  const { locale } = selectedCountry;

  return (
    <Styles
      className="Day"
      disabled={disabled}
      onClick={() => onClick(date)}
      selected={isSelected}
    >
      <p className="Day__name">
        {titleCase(dayjs(date).locale(locale).format("ddd"))}
      </p>
      <p className="Day__number">{date.format("DD")}</p>
    </Styles>
  );
};

export default Day;
